/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

export enum TourClass {
  All = '',
  Delivery = 'lieferung',
  Return = 'freimeldung',
  Service = 'service',
  Maintenance = 'wartung'
}
